import React from 'react';
import { Link } from 'react-router-dom';
import { Facebook, Twitter, Instagram, Linkedin, Youtube } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="bg-slate-900 text-white py-24">
      <div className="max-w-7xl mx-auto px-4 sm:px-8 md:px-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12">
          {/* About */}
          <div>
            <h3 className="text-xl font-bold mb-4">The Pune Perspective</h3>
            <p className="text-sm text-slate-300 leading-relaxed">
              Your trusted source for automotive news, industry insights, and Pune local stories.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-sm font-bold tracking-[0.2em] uppercase mb-4">Quick Links</h4>
            <ul className="space-y-2">
              <Link to="/about" className="block text-sm text-slate-300 hover:text-white transition-colors" data-testid="footer-about-link">About Us</Link>
              <Link to="/contact" className="block text-sm text-slate-300 hover:text-white transition-colors" data-testid="footer-contact-link">Contact</Link>
              <Link to="/advertise" className="block text-sm text-slate-300 hover:text-white transition-colors" data-testid="footer-advertise-link">Advertise With Us</Link>
              <Link to="/admin" className="block text-sm text-slate-300 hover:text-white transition-colors" data-testid="footer-admin-link">Admin</Link>
            </ul>
          </div>

          {/* Categories */}
          <div>
            <h4 className="text-sm font-bold tracking-[0.2em] uppercase mb-4">Categories</h4>
            <ul className="space-y-2">
              <Link to="/category/automotive" className="block text-sm text-slate-300 hover:text-white transition-colors" data-testid="footer-cat-automotive">Automotive</Link>
              <Link to="/category/pune-local" className="block text-sm text-slate-300 hover:text-white transition-colors" data-testid="footer-cat-pune">Pune Local</Link>
              <Link to="/category/industry-insights" className="block text-sm text-slate-300 hover:text-white transition-colors" data-testid="footer-cat-insights">Industry Insights</Link>
              <Link to="/category/reviews" className="block text-sm text-slate-300 hover:text-white transition-colors" data-testid="footer-cat-reviews">Reviews</Link>
            </ul>
          </div>

          {/* Legal */}
          <div>
            <h4 className="text-sm font-bold tracking-[0.2em] uppercase mb-4">Legal</h4>
            <ul className="space-y-2">
              <Link to="/privacy" className="block text-sm text-slate-300 hover:text-white transition-colors" data-testid="footer-privacy-link">Privacy Policy</Link>
              <Link to="/disclaimer" className="block text-sm text-slate-300 hover:text-white transition-colors" data-testid="footer-disclaimer-link">Disclaimer</Link>
            </ul>
            <div className="mt-6 flex space-x-4">
              <a href="https://www.linkedin.com/in/alex-kim-5ba55276" target="_blank" rel="noopener noreferrer" className="text-slate-300 hover:text-white transition-colors" data-testid="social-linkedin">
                <Linkedin className="w-5 h-5" />
              </a>
            </div>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-slate-700 text-center text-sm text-slate-400">
          <p>© {new Date().getFullYear()} The Pune Perspective. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
